var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{style:('min-height:' + this.$parent.heightAfterHeaderFooter + 'px'),attrs:{"id":"fullWidthContent"}},[_c('b-form',{staticClass:"margined"},[_c('h2',[_vm._v("You have logged out")])])],1)}
var staticRenderFns = []

export { render, staticRenderFns }